/**------------- Our Values constants -------------**/

/*  Title  */
export const OUR_VALUES_TITLE = "Ciò in cui crediamo.";

/*  Steps  */
export const OUR_VALUES_STEPS_CLASS_NAME =
	"our-values-steps";
export const OUR_VALUES_STEPS_DIRECTION = "vertical";
export const OUR_VALUES_ALL_STEPS = [
	{
		title: "Impegno",
		description:
			"Ci dedichiamo a soddisfare ogni esigenza, andando oltre le aspettative.",
	},
	{
		title: "Qualità",
		description:
			"Garantiamo risultati di alto livello ed innovazione in ogni intervento.",
	},
	{
		title: "Fiducia",
		description:
			"Agiamo con trasparenza e serietà, costruendo relazioni solide e durature.",
	},
];
